import { type Entity } from "@client/types";
import { type Tag } from "@client/types/Tag";
import { unique } from "./array";

export const expandTags = (tags: string | undefined) => (tags || "").split(",").map((t) => <Tag>{ id: t, text: t });

export const expandTagsArray = (tags: string[]): Tag[] => {
  const allTags = tags.reduce((res, t) => [...res, ...(t || "").split(",")], []);
  return unique(allTags).map((t) => <Tag>{ id: t, text: t });
};

export const getCTItemTags = (item: Entity): Tag[] => expandTags(item.settings?.tags as string);
